





































































































import { Component, Vue } from 'vue-property-decorator'
import REPORT_COLUMNS from '@/config/reportForm/column-config/sale-details'
import { setSessionStorage } from '../../../store/src/utils/index'
@Component
export default class Login extends Vue {
	private reportFormId: string = 'XSMX_100001'
	private settingCols: any = REPORT_COLUMNS
	private gridData: any = []
	private hidecCols: string = ''
	private sumCol: any = {}
	private dateValue: any = []
	private billState: string = ''
	private filterFormData: any = {
		dateType: '0',
		restaurantName: '',
		fromOrganName: '',
		toOrganName: '',
		goodsName: '',
		transBillNo: '',
		billState: '',
		billType: ''
	}
	private restaurantList: any = []
	private fromOrganList: any = []
	private toOrganList: any = []
	private onChangeColData (hideCol: string) {
		this.hidecCols = hideCol
	}
	private onRestaurantChange (id: []) {
		this.filterFormData.fromOrganName = []
	}
	private async onSearch () {
		const searchFilter = await this.searchFilter('1')
		await this.searchHandler(searchFilter)
	}
	private searchFilter (ediExportParams?: string) {
		return new Promise((resolve: any) => {
			const settingMenuParams = this.settingCols.map((item) => {
				return item.prop
			})
			const params = {
				filters: {rules: this.getFiltersParams().filtersParams},
				rows: 30,
				page: 1,
				validcols: settingMenuParams.join(','),
				ediExportHideCols: ediExportParams
			}
			resolve(params)
		})
	}
	private searchHandler (params) {
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getXSMX100001Data',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private onExport () {
		this.exportFun()
	}
	private async exportFun () {
		const hideCols = this.hidecCols
		const searchFilter = await this.searchFilter(hideCols)
		const searchHandler = await this.searchHandler(searchFilter)
		await this.exportHandler(searchHandler)
	}
	private exportHandler (params) {
		window.open('/cldEdi/reportDateController/exportEdiDataCommon.do?exportType=1')
	}
	private onSortChange ({ prop, order }) {
		const settingMenuParams = this.settingCols.map((item) => {
			return item.prop
		})
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			rows: 30,
			page: 1,
			validcols: settingMenuParams.join(','),
			sord: prop === null ? null : order === 'ascending' ? 'asc' : 'desc',
			sidx: prop
		}
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getXSMX100001Data',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private setGridData (gridObj) {
		this.gridData = gridObj.currentData || []
		this.sumCol = gridObj.userdata || {}
	}
	private created () {
		setSessionStorage('titleLabel', '销售明细表')
		this.initFilters()
		this.initOrganFilterData()
	}
	private initOrganFilterData () {
		return (this as any).$fxHttp.requestPost({
			url: '/reportDateController/getXSMX10001ConfigOrgan'
		}).then((res: any) => {
			this.restaurantList = res.restaurantList
			this.fromOrganList = res.fromOrganList
			this.toOrganList = res.toOrganList
			return Promise.resolve()
		})
	}
	private initFilters () {
		this.dateValue = [(this as any).$fxCommon.orderFilterStartDate(), (this as any).$fxCommon.orderFilterEndDate()]
	}
	private getFiltersParams () {
		const filtersParams = [] as any
		if (this.filterFormData.dateType !== '') {
			const billState = { field: 'date_type', data: this.filterFormData.dateType, op: 'eq' }
			filtersParams.push(billState)
		}
		if (this.filterFormData.restaurantName) {
			const restaurantName = { field: 'restaurant_name', data: this.filterFormData.restaurantName, op: 'cn' }
			filtersParams.push(restaurantName)
		}
		if (this.filterFormData.fromOrganName) {
			const fromOrganName = { field: 'from_organ_name', data: this.filterFormData.fromOrganName, op: 'cn' }
			filtersParams.push(fromOrganName)
		}
		if (this.filterFormData.toOrganName) {
			const toOrganName = { field: 'to_organ_name', data: this.filterFormData.toOrganName, op: 'cn' }
			filtersParams.push(toOrganName)
		}
		if (this.filterFormData.goodsName) {
			const goodsName = { field: 'goods_name', data: this.filterFormData.goodsName, op: 'cn' }
			filtersParams.push(goodsName)
		}
		if (this.filterFormData.transBillNo) {
			const transBillNo = { field: 'trans_bill_no', data: this.filterFormData.transBillNo, op: 'cn' }
			filtersParams.push(transBillNo)
		}
		if (this.filterFormData.billType) {
			const billType = { field: 'bill_type', data: this.filterFormData.billType, op: 'eq' }
			filtersParams.push(billType)
		}
		if (this.dateValue === '' ||
			this.dateValue === null ||
			this.dateValue === undefined) {
			filtersParams.push(
				{ field: 'from_date', data: `${(this as any).$fxCommon.orderFilterStartDate()} 00:00`, op: 'ge' },
				{ field: 'from_date', data: `${(this as any).$fxCommon.orderFilterEndDate()} 23:59`, op: 'le' }
			)
		} else {
			filtersParams.push(
				{ field: 'from_date', data: `${this.dateValue[0]} 00:00`, op: 'ge' },
				{ field: 'from_date', data: `${this.dateValue[1]} 23:59`, op: 'le' }
			)
		}
		if (this.filterFormData.billState !== '') {
			const billState = { field: 'bill_state', data: this.filterFormData.billState, op: 'eq' }
			filtersParams.push(billState)
		}
		return {
			filtersParams
		}
	}
}
